import { useEffect } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import Button from "@atlaskit/button";

import { useAnalyticsClient } from "@/analytics/wac-analytics";

import { LeftHandSidePageProjectDetails } from "../../../../onboarding-wizard/wizard/page-project-details/left-hand-side/left-hand-side";
import { StepContext, StepProps } from "../../../types";
import { Header } from "../../components/header";

import { stepMessages } from "./messages";

export const SpaceDetails = <T extends StepContext>({
    context,
    setContext,
    onSubmit,
    nextStep
}: StepProps<T>) => {
    const { formatMessage } = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const analyticsClient = useAnalyticsClient();

    useEffect(() => {
        if (!analyticsClient) {
            return;
        }
        createAnalyticsEvent({
            action: "viewed",
            actionSubject: "screen",
            actionSubjectId: "spaceDetailsStep",
            eventType: "screen",
            name: "spaceDetailsStep",
            attributes: {
                teamType: context.teamType || "unknown"
            }
        }).fire();
    }, [createAnalyticsEvent, analyticsClient, context.teamType]);

    const handleSpaceNameChange = (spaceName: string) => {
        setContext(
            (prevContext: T | undefined) =>
                ({
                    ...prevContext,
                    spaceName
                } as T)
        );
    };

    const SubmitButton = (
        <Button type="submit" appearance="primary">
            {formatMessage(stepMessages.nextBtn)}
        </Button>
    );

    return (
        <div css={containerCss}>
            <LeftHandSidePageProjectDetails
                currentProjectName={context?.spaceName ?? ""}
                defaultProjectName={context?.spaceName ?? ""}
                onProjectNameChange={handleSpaceNameChange}
                onClickNext={() => {
                    if (onSubmit) {
                        onSubmit({ context, setContext });
                    }

                    nextStep();
                }}
                Header={Header}
                submitButton={SubmitButton}
            />
        </div>
    );
};

const containerCss = css({
    display: "flex",
    justifyContent: "center",
    height: "100%"
});
